export const LandlordNotesTab = () => {
    const tabName = "Notes";
    const ref = tabName.toLocaleLowerCase();

    return (
        <>
            <h3 className="mt-10px">{tabName}</h3>
            <div className="col-xl-6" key={ref}>
                <p>
                    # TODO: Add Notes UI
                </p>

            </div>
        </>
    );
};